import Moment from 'moment';

export function getFormattedNumber(
  numberString: string | number,
  maxFractionDigits = 2,
  formatNulls = true,
) {
  if (!formatNulls && !numberString) {
    return numberString;
  }

  const number = +numberString;
  if (Number.isNaN(number)) {
    return numberString;
  }
  return number.toLocaleString(`en-GB`, {
    maximumFractionDigits: maxFractionDigits,
  });
}

export function tryGetYearFromDateString(dateString: string) {
  if (!dateString) {
    return null;
  }

  return new Date(dateString).getFullYear();
}

export const getPageTitle = (platformName: string, suffix?: string): string =>
  `${platformName} ${suffix ? `- ${suffix}` : ``}`.trim();

export function sanitizeText(text: string) {
  if (!text) return `_`;

  return text
    .replace(/\s/g, `-`)
    .replace(/[^\w-]/g, ``)
    .toLocaleLowerCase();
}

export const formatCourseDropdownLabel = (label: string): string => {
  return (
    label
      .replace(/(\d)([a-zA-Z])/g, '$1 $2')
      //.toLowerCase()
      .split(' ')
      .map((el) => el.charAt(0).toUpperCase() + el.slice(1))
      .join(' ')
  );
};

export const formatCourseInstanceDate = (dates: string[]): string[] => {
  return [
    ...new Set(
      dates
        .sort((a, b) => Date.parse(a) - Date.parse(b))
        .map((c) => Moment(new Date(c)).format('DD MMMM yy')),
    ),
  ];
};

export const formatSummaryInstanceDate = (dates: string[]): string[] => {
  return dates.map((c) =>
    !!c ? (c === 'TBC' ? c : Moment(new Date(c)).format('Do MMMM yy')) : 'TBC',
  );
};

export const formatMonthfromDate = (dateString: string, locale: Intl.LocalesArgument) => {
  if (locale == 'zh-CN') dateString = dateString.replace(/年|月/g, '-').replace(/日/g, '');
  const date = new Date(dateString);
  return date.toLocaleDateString(locale, { month: 'long' });
};

export const removeSpacefromText = (text: string, mode: 'trim' | 'normalize' | 'all' = 'all'): string => {
  switch (mode) {
    case 'trim':
      return text.trim();
    case 'normalize':
      return text.replace(/\s+/g, ' ').trim();
    case 'all':
    default:
      return text.replace(/\s+/g, '');
  }
};
